__turbopack_context__.v({
  "accent": "IconButton-module-scss-module__39QKKq__accent",
  "big": "IconButton-module-scss-module__39QKKq__big",
  "button": "IconButton-module-scss-module__39QKKq__button",
  "end_icon": "IconButton-module-scss-module__39QKKq__end_icon",
  "expand": "IconButton-module-scss-module__39QKKq__expand",
  "icon": "IconButton-module-scss-module__39QKKq__icon",
  "is_with_icons": "IconButton-module-scss-module__39QKKq__is_with_icons",
  "loader": "IconButton-module-scss-module__39QKKq__loader",
  "medium": "IconButton-module-scss-module__39QKKq__medium",
  "on-bg": "IconButton-module-scss-module__39QKKq__on-bg",
  "on-color-fill": "IconButton-module-scss-module__39QKKq__on-color-fill",
  "on-surface": "IconButton-module-scss-module__39QKKq__on-surface",
  "rounded": "IconButton-module-scss-module__39QKKq__rounded",
  "simple": "IconButton-module-scss-module__39QKKq__simple",
  "small": "IconButton-module-scss-module__39QKKq__small",
  "spinner": "IconButton-module-scss-module__39QKKq__spinner",
  "start_icon": "IconButton-module-scss-module__39QKKq__start_icon",
});
